// extracted by mini-css-extract-plugin
export const homeImage = "index-module--homeImage--3qxZp";
export const column = "index-module--column--1B3Z2";
export const columnTitle = "index-module--columnTitle--17QKF";
export const columnText = "index-module--columnText--1mbXi";
export const actionButton = "index-module--actionButton--tIfBY";